<template>
    <div class="card card-eco">
        <div class="card-body">
            <h4 class="title-text mt-0">{{name}}</h4>
            <div class="d-flex justify-content-between">
                <h3 class="font-weight-bold">{{total}}</h3>
                <i class="card-eco-icon align-self-center" :class="[icon, color]"></i>
            </div>                                     
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'name',
        'total',
        'icon',
        'color'
    ]
}
</script>